import { render, staticRenderFns } from "./password.vue?vue&type=template&id=f01a909a&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f01a909a')) {
      api.createRecord('f01a909a', component.options)
    } else {
      api.reload('f01a909a', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=f01a909a&", function () {
      api.rerender('f01a909a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/password.vue"
export default component.exports